<div 
    #neighborsContainer
    [class.hidden]="!showElement()" 
    class="py-2.5 px-3 min-w-[250px] sm:min-w-auto md:max-w-80 h-8 mx-auto flex justify-center items-center rounded-full relative bg-semiblack"
>
    <!-- LEFT SECTION BUTTON -->
    @if( leftSection ) {
        
        <div
            [class]="leftSection === 'none' ? 'opacity-0 pointer-events-none' : ''"
            class="md:flex flex-row-reverse items-center justify-between cursor-pointer absolute left-3.5 md:-left-[31%] w-8 md:w-[124px] h-8  group transition-opacity"
            tabindex="0"
            (click)="navigateToSection(sectionData()!.l)"
            (keypress.enter)="navigateToSection(sectionData()!.l)"
        >

            <!-- ARROW ICON -->
            <div
                class="flex items-center h-full transition-colors group-hover:bg-semiblack"
            >
                
                <i class="text-white block my-auto">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                </i>

            </div>
            
            <!-- SECTION -->
            <div class="hidden md:flex opacity-0 group-hover:opacity-100 transition-opacity flex-grow h-full items-center pl-5 pr-2 rounded-l-full bg-semiblack">
                    
                <p class="text-white text-xxs font-semibold uppercase">
                    
                    <span class="opacity-70 whitespace-nowrap">	
                        {{ modeLr() ? translation.getText('neighbors', 'left_section') : translation.getText('general', 'section') }}&nbsp;
                    </span>


                    @if(leftSection !== 'none' && !modeLr()){
                        <span #leftSectionNumber class="whitespace-nowrap">
                            {{ leftSection | dvmFormatter }}
                        </span>
                    }
                    

                </p>

            </div>


        </div>  

    }

    <!-- CURRENT SECTION TEXT -->
    <div class="block mx-auto cursor-default">
        
        @if( isLoading3d() ){
            <p class="text-xs font-semibold text-white">
                <span>
                    Loading
                </span>
            </p>
        }
        
        @else {
            
            <!-- SEAT MAP -->
            @if(selectedSection()){

                <h3 class="text-white text-xxs font-semibold uppercase flex">
                
                    <span [class]="{
                      'hidden': (is3d && !isGaException()) || !!viewId,
                      'text-vip': sectionIsPremium,
                      'opacity-70': !sectionIsPremium
                    }">	
                        {{translation.getText('general', 'section')}} &nbsp;
                    </span>

                    <!-- If there is a current related preview active, display its label instead of the section (only for indoor) -->
                    @if(is3d && currentPreview() && currentPreview()?.view_id !== initialViewId) {
                      <span [innerHTML]="currentPreview()?.label"></span>
                    } @else {
                      <p #currentSection [innerHTML]="selectedSection()"></p>
                    }

                    
                </h3>

            }
        
        }

    </div>
    
    <!-- RIGHT SECTION BUTTON -->
    @if( rightSection ) {

        <div 
            [class]="rightSection === 'none' ? 'opacity-0 pointer-events-none' : ''"
            class="cursor-pointer absolute right-3.5 md:-right-[31%] w-8 md:w-[124px] h-8 md:flex flex-row items-center justify-between group transition-opacity"
            tabindex="1"
            (click)="navigateToSection(sectionData()!.r)"
            (keypress.enter)="navigateToSection(sectionData()!.r)"
        >
            <!-- ICON ARROW -->
            <div 
                class="flex justify-end md:justify-normal items-center h-full transition-colors group-hover:bg-semiblack"
            >
                
                <i class="text-white block ">
                    
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                        
                </i>
            </div>
            
            <!-- SECTION -->
            <div class="opacity-0 group-hover:opacity-100 transition-opacity hidden md:flex flex-grow h-full items-center pl-2 pr-5 rounded-r-full bg-semiblack">
                
                <p class="text-white text-xxs font-semibold uppercase">
                    
                    <span class="opacity-70 whitespace-nowrap">	
                        {{ modeLr() ? translation.getText('neighbors', 'right_section') : translation.getText('general', 'section') }}&nbsp;
                    </span>

                    @if(rightSection !== 'none' && !modeLr()){

                        <span #rightSectionNumber class="whitespace-nowrap">
                            {{ rightSection | dvmFormatter}}
                        </span>
                       
                    }

                </p>

            </div>
        
        </div>
        
    }


</div>
    
